import React from 'react';
import { motion } from 'framer-motion';
import { Car, ShieldCheck, Database, Zap } from 'lucide-react';
import Navigation from '@/components/Navigation';
import Footer from '@/components/Footer';

const About = () => {
  return (
    <div className="min-h-screen bg-background">
      <Navigation />
      
      <div className="container mx-auto px-4 lg:px-8 pt-32 pb-20">
        <div className="max-w-4xl mx-auto">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
          >
            <h1 className="heading-font text-5xl sm:text-6xl font-bold mb-6">
              About VIN Check
            </h1>
            
            <p className="text-lg text-muted-foreground mb-12">
              Your trusted source for accurate vehicle information powered by official NHTSA data.
            </p>
            
            <div className="space-y-8 mb-16">
              <div className="bg-card border border-border/50 rounded-sm p-8">
                <div className="flex items-start gap-4">
                  <div className="p-3 bg-primary/10 rounded-sm text-primary">
                    <Car className="h-6 w-6" />
                  </div>
                  <div>
                    <h2 className="heading-font text-2xl font-bold mb-3">What is VIN Check?</h2>
                    <p className="text-muted-foreground leading-relaxed">
                      VIN Check is a professional vehicle identification number decoder that provides instant access to comprehensive vehicle information. We decode 17-character VINs to reveal make, model, year, specifications, and manufacturing details.
                    </p>
                  </div>
                </div>
              </div>
              
              <div className="bg-card border border-border/50 rounded-sm p-8">
                <div className="flex items-start gap-4">
                  <div className="p-3 bg-primary/10 rounded-sm text-primary">
                    <Database className="h-6 w-6" />
                  </div>
                  <div>
                    <h2 className="heading-font text-2xl font-bold mb-3">Official NHTSA Data</h2>
                    <p className="text-muted-foreground leading-relaxed">
                      All vehicle information is sourced directly from the National Highway Traffic Safety Administration (NHTSA) database. This ensures you receive accurate, government-verified data for every VIN search.
                    </p>
                  </div>
                </div>
              </div>
              
              <div className="bg-card border border-border/50 rounded-sm p-8">
                <div className="flex items-start gap-4">
                  <div className="p-3 bg-primary/10 rounded-sm text-primary">
                    <Zap className="h-6 w-6" />
                  </div>
                  <div>
                    <h2 className="heading-font text-2xl font-bold mb-3">Fast & Free</h2>
                    <p className="text-muted-foreground leading-relaxed">
                      Get instant results with our lightning-fast VIN decoding service. No registration required, no hidden fees. Simply enter a VIN and access comprehensive vehicle information immediately.
                    </p>
                  </div>
                </div>
              </div>
              
              <div className="bg-card border border-border/50 rounded-sm p-8">
                <div className="flex items-start gap-4">
                  <div className="p-3 bg-primary/10 rounded-sm text-primary">
                    <ShieldCheck className="h-6 w-6" />
                  </div>
                  <div>
                    <h2 className="heading-font text-2xl font-bold mb-3">Why Use VIN Check?</h2>
                    <ul className="space-y-2 text-muted-foreground">
                      <li className="flex items-start gap-2">
                        <span className="text-primary mt-1">•</span>
                        <span>Verify vehicle specifications before purchasing</span>
                      </li>
                      <li className="flex items-start gap-2">
                        <span className="text-primary mt-1">•</span>
                        <span>Check vehicle history and manufacturing details</span>
                      </li>
                      <li className="flex items-start gap-2">
                        <span className="text-primary mt-1">•</span>
                        <span>Access official government database information</span>
                      </li>
                      <li className="flex items-start gap-2">
                        <span className="text-primary mt-1">•</span>
                        <span>Research vehicle options and specifications</span>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            
            <div className="bg-muted/30 border border-border/50 rounded-sm p-8">
              <h3 className="heading-font text-xl font-bold mb-4">Contact Information</h3>
              <p className="text-muted-foreground mb-2">
                For questions or support, please contact us:
              </p>
              <p className="text-primary font-medium">support@vincheck.com</p>
            </div>
          </motion.div>
        </div>
      </div>
      
      <Footer />
    </div>
  );
};

export default About;
